import React, { useState, useMemo, useEffect } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useQuery } from "components/graphql/query/use-query";
import { QueryResponseHandler } from "components/graphql";
import { defaultValues, mutation, handleSubmit, validationSchema, EditAssetForm } from "./forms/edit-form";
import { getAssetQuery } from "./details-page";
import ValidatedForm from "components/form";
import { Restricted, permissions } from "components/auth";
import { FormattedMessage } from "react-intl";

const AssetEditPage = ({
  intl,
  history,
  match: {
    params: { id },
  },
}) => {
  const [updateAsset] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getAssetQuery(id, currentCustomerId), [id, currentCustomerId]);
  const { data, loading, error } = useQuery(query);

  const [initialValues, setInitialValues] = useState(defaultValues);
  const assetToEdit = data ? data.asset : null;

  useEffect(
    () => {
      if (assetToEdit) {
        setInitialValues({
          codename: assetToEdit.codename || "",
          description: assetToEdit.description || "",
          categoryIds: assetToEdit.categoryIds || [],
        });
      }
    },
    [assetToEdit],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={assetToEdit}>
        <Restricted
          fallback={
            <h1>
              <FormattedMessage id="common.security.noAccess" />
            </h1>
          }
          permissions={[
            assetToEdit && assetToEdit.customerId ? permissions.asset_manage : permissions.asset_common_manage,
          ]}
        >
          <PageHeaderBar title="app.page.asset.edit" />
          <PageSection>
            <ValidatedForm
              initialValues={initialValues}
              validationSchema={validationSchema(intl)}
              onSubmit={handleSubmit({
                updateAsset,
                history,
                assetToEdit,
                currentCustomerId,
              })}
            >
              {props => (
                <DataGrid>
                  <EditAssetForm defaultCategories={["OTHER"]} {...props} />
                </DataGrid>
              )}
            </ValidatedForm>
          </PageSection>
        </Restricted>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default AssetEditPage;
